module.exports = __webpack_public_path__ + "img/i-4.eb73d053.svg";